import { Button as MuiButton } from '@mui/material';
import React from 'react';
import { styled } from '@mui/material/styles';

import MenuIcon from '../../assets/icon/menu-icon';

const ButtonStyle = styled(MuiButton)(({ theme }) => ({
  '&:hover': {
    background: theme.palette.primary.contrastText,
  },
  background: theme.palette.primary.contrastText,
  color: 'white',
  [theme.breakpoints.down('sm')]: {
    fontSize: '.7rem',
  },
}));

type PropTypes = {
  onClick: any;
  title: string;
};

export default function Button({ onClick, title }: PropTypes) {
  return (
    <ButtonStyle
      endIcon={<MenuIcon />}
      onClick={onClick}
      size="small"
      title={title}
      variant="contained"
    >
      {title}
    </ButtonStyle>
  );
}
